import React from 'react';
import { Paper, Typography } from '@mui/material';
import AdminOverviewExternalLinks from '../AdminOverviewExternalLinks';

export default function ExternalLinksSnapshotWidget({ userData, onManageLinks }) {
  return (
    <Paper variant="outlined" sx={{ p: 2, height: '100%' }}>
      <Typography variant="h6" sx={{ mb: 1 }}>
        External links snapshot
      </Typography>
      <AdminOverviewExternalLinks userData={userData} onManageLinks={onManageLinks} />
    </Paper>
  );
}
